import type { StakeRecord, } from "../../types";

export const data:StakeRecord[] = [
    { "token": "wstETH", "deposit": 0.022, "boost": "2x", "balance": 0 },
    { "token": "rETH", "deposit": 1.321, "boost": "3x", "balance": 0 },
    { "token": "eETH", "deposit": 0.22, "boost": "1.5x", "balance": 0 },
    { "token": "ezETH", "deposit": 2123.2123, "boost": "none", "balance": 0 }
] 

export default data;
